import { loadStripe } from "@stripe/stripe-js";

export function registerStripeCheckout() {
    window.Alpine.data("stripeCheckout", (config = {}) => {
        return {
            paymentIntentId: config.paymentIntentId,
            clientSecret: config.clientSecret,
            publishableKey: config.publishableKey,
            elementId: config.elementId,
            onSuccess: config.onSuccess || null,
            returnUrl: config.returnUrl || window.location.href,
            locale: config.locale || "auto",

            stripe: null,
            elements: null,
            isProcessing: false,
            errorMessage: "",
            checkoutReady: false,

            async init() {
                try {
                    this.stripe = await loadStripe(this.publishableKey, {
                        locale: this.locale,
                    });

                    if (!this.stripe) {
                        throw new Error("Failed to load Stripe");
                    }

                    this.elements = this.stripe.elements({
                        clientSecret: this.clientSecret,
                        locale: this.locale,
                        appearance: {
                            theme: "stripe",
                            variables: {
                                colorPrimary: "#E74C3C",
                            },
                        },
                    });

                    const paymentElement = this.elements.create("payment", {
                        layout: {
                            defaultCollapsed: false,
                            type: "accordion",
                        },
                    });
                    paymentElement.mount(`#${this.elementId}`);

                    paymentElement.on("ready", () => {
                        this.checkoutReady = true;
                    });
                } catch (error) {
                    console.error("Stripe initialization error:", error);
                }
            },

            async handleSubmit() {
                if (this.isProcessing || !this.checkoutReady) {
                    return;
                }

                this.isProcessing = true;

                try {
                    const { error, paymentIntent } =
                        await this.stripe.confirmPayment({
                            elements: this.elements,
                            confirmParams: {
                                return_url: this.returnUrl,
                            },
                        });

                    console.log(error);

                    if (error) {
                        this.errorMessage = error.message;
                        this.isProcessing = false;

                        return;
                    }

                    if (
                        paymentIntent?.status === "succeeded" &&
                        this.onSuccess
                    ) {
                        this.onSuccess();
                    }
                } catch (error) {
                    this.errorMessage =
                        "An unexpected error occurred. Please try again.";

                    this.isProcessing = false;
                }
            },
        };
    });
}
